
import Vue, { PropType } from 'vue'
import { CompanyUser } from '@/models'
import BaseTableCellContent from '@/components/BaseTableCellContent.vue'

export default Vue.extend({
  name: 'CompanyUserListItem',

  components: {
      BaseTableCellContent
  },

  props: {
    companyUser: Object as PropType<CompanyUser>
  },

  methods: {
      showDeleteScreen(): void {
          this.$router.push({
              name: 'company-user-delete',
              params: {
                  companyUserId: this.companyUser.id as string
              }
          })
      }
  }
})
